import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, finalize, switchMap, take, tap } from 'rxjs/operators';
import { ScanService } from '../../services/scan.service';
import { MatDialogRef } from '@angular/material/dialog';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-scan-input-modal',
  templateUrl: './scan-input-modal.component.html',
  styleUrls: ['./scan-input-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ScanInputModalComponent implements OnInit {
  title = {
    sku: 'SKU',
    order: 'Shipping label',
  };
  @Input() modalType: 'sku' | 'order';
  @ViewChild(MatInput) barcodeInputRef: MatInput;

  barcodeForm = new UntypedFormGroup({
    barcode: new UntypedFormControl('', [Validators.required]),
  });
  submitting = false;
  public showContainer: boolean;
  constructor(
    private scanService: ScanService,
    public dialogRef: MatDialogRef<any>,
    public breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit(): void {
    this.breakpointObserver.observe(['(max-width: 440px)']).subscribe((state: BreakpointState) => {
      this.showContainer = state.matches;
    });
    this.changePosition();
    if (this.showContainer) {
      this.updatePosition();
    }
    this.barcodeForm.controls.barcode.valueChanges.pipe(untilDestroyed(this)).subscribe((barcodeValue) => {
      this.barcodeForm.patchValue(
        {
          barcode: barcodeValue?.trim(),
        },
        { emitEvent: false },
      );
    });

    // javascript input not focused
    document.addEventListener('keypress', function (scanWithOutInputTouch) {
      // @ts-ignore
      if (scanWithOutInputTouch.target.tagName !== 'INPUT') {
        const input = document.querySelector('.barcode');
        // @ts-ignore
        input.focus();
        // @ts-ignore
        input.value = scanWithOutInputTouch.key;
        scanWithOutInputTouch.preventDefault();
      }
    });
  }

  changePosition() {
    this.dialogRef.updatePosition({ top: '7px' });
  }

  updatePosition() {
    this.dialogRef.updateSize('100%', '100vh');
  }

  onSubmit(): void {
    this.submitting = true;
    switch (this.modalType) {
      case 'sku':
        this.scanService.itemScanned$
          .pipe(
            untilDestroyed(this),
            take(1),
            finalize(() => {
              this.submitting = false;
              this.barcodeForm.reset();
            }),
          )
          .subscribe();
        this.scanService.scanSkuBarcode(this.barcodeForm.value.barcode);
        break;
      case 'order':
        this.scanService
          .getOrdersByShippingId(this.barcodeForm.value.barcode)
          .pipe(
            untilDestroyed(this),
            tap((orders) => {
              if (orders.length > 1) {
                this.scanService.toggleScanSelectOrdersDialog(orders);
              }
            }),
            filter((orders) => orders.length === 1),
            switchMap((orders) => {
              return this.scanService.syncAndScanOrder(orders[0].id, orders[0].shippingId);
            }),
            finalize(() => {
              this.submitting = false;
              this.barcodeForm.reset();
            }),
          )
          .subscribe((order) => {
            this.scanService.toggleScanOrderDialogOpened(order);
          });

        break;
    }
  }
}
